import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/common.css';
import '@/assets/css/animate.css';
Vue.config.productionTip = false
Vue.prototype.$globalData = {
  isMob: false
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
